import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import LocationsPage from "@/pages/LocationsPage";
import AreasPage from "@/pages/AreasPage";
import HistoryPage from "@/pages/HistoryPage";
import UsersPage from "@/pages/UsersPage";
import CheckInPage from "@/pages/CheckInPage";
import CompliancePage from "@/pages/CompliancePage";
import IncidentsPage from "@/pages/IncidentsPage";
import ScanLandingPage from "@/pages/ScanLandingPage";
import PublicReportPage from "@/pages/PublicReportPage";
import AdminToolsPage from "@/pages/AdminToolsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/scan/:areaId" element={<ScanLandingPage />} />
            <Route path="/report/:areaId" element={<PublicReportPage />} />
            <Route path="/check/:areaId" element={<ProtectedRoute><CheckInPage /></ProtectedRoute>} />
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/compliance" element={<CompliancePage />} />
              <Route path="/incidents" element={<IncidentsPage />} />
              <Route path="/clients" element={<ProtectedRoute roles={["admin", "supervisor"]}><ClientsPage /></ProtectedRoute>} />
              <Route path="/locations" element={<LocationsPage />} />
              <Route path="/areas" element={<AreasPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/users" element={<ProtectedRoute roles={["admin", "supervisor"]}><UsersPage /></ProtectedRoute>} />
              <Route path="/tools" element={<ProtectedRoute roles={["admin"]}><AdminToolsPage /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
